// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Hint';



// WEBPACK FOOTER //
// ./components/Hint/index.js